import { styled } from '@linaria/react';

import { fonts, primitives, radius, semantic, size, space, textStyle } from '../../theme/tokens';

export const Panel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  padding: ${space['space-800']} ${space['space-600']} ${space['space-600']};
`;

export const HeadingBlock = styled.div`
  text-align: center;
  margin-bottom: var(--voyager-signin-header-gap, 0);
`;

export const Heading = styled.h2`
  font-family: ${textStyle.display['size-md'].fontFamily};
  font-size: var(--voyager-signin-heading-size, ${fonts.size.xl});
  font-weight: var(--voyager-signin-heading-weight, ${fonts.weight.normal});
  color: ${semantic.text.primary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.tight};
  letter-spacing: var(--voyager-signin-heading-tracking, normal);
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const SignUpRow = styled.p`
  font-family: ${fonts.body};
  font-size: var(--voyager-signin-subtitle-size, ${fonts.size.sm});
  color: ${semantic.text.primary};
  margin: var(--voyager-signin-title-gap, ${space['space-200']}) 0 0;
  text-align: center;
`;

export const InlineLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  color: ${semantic.text.primary};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const FormBlock = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--voyager-signin-form-gap, ${space['space-300']});
`;

export const InsetField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const ForgotRow = styled.div`
  text-align: center;
  margin-top: ${space['space-200']};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${space['space-300']};
  right: ${space['space-300']};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${space['space-200']};
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  background: none;
  color: ${semantic.icon.primary};
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;

export const FormError = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.danger};
  text-align: center;
`;
